import { Decrypt, Encrypt } from "@/utils/crypto.js";

export const LetterArr = [
  "",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "S",
  "Y",
  "Z"
];

export function AddUserAnswerAndDecryptAnswer(T) {
  for (let tIndex = 0; tIndex < T.length; tIndex++) {
    if (T[tIndex].type == 1 || T[tIndex].type == 2) {
      //T[tIndex].userAnswer = [1];
      if (
        !T[tIndex].hasOwnProperty("userAnswer") ||
        !Array.isArray(T[tIndex].userAnswer)
      ) {
        T[tIndex].userAnswer = [];
      }
      T[tIndex].answer =
        Decrypt(T[tIndex].answer, T[tIndex].questionId).split(",") || [];
    } else {
      T[tIndex].sonQuestion.forEach((r, i) => {
        let question = T[tIndex].sonQuestion[i];
        //question.userAnswer = [1];
        if (
          !question.hasOwnProperty("userAnswer") ||
          !Array.isArray(question.userAnswer)
        ) {
          question.userAnswer = [];
        }
        //console.log(question.answer, question.questionId);
        //console.log(Decrypt(T[tIndex].answer, T[tIndex].questionId));
        question.answer =
          Decrypt(question.answer, question.questionId).split(",") || [];
        //question.answer = [];
      });
    }
    // if(T[tIndex].type == 3 || T[tIndex].type == 4 || T[tIndex].type == 5){
    //
    // }
  }
  return T;
}
export function RemoveUserAnswer(T) {
  for (let tIndex = 0; tIndex < T.length; tIndex++) {
    if (T[tIndex].type == 1 || T[tIndex].type == 2) {
      T[tIndex].userAnswer = [];
    } else {
      T[tIndex].sonQuestion.forEach((r, i) => {
        T[tIndex].sonQuestion[i].userAnswer = [];
      });
    }
  }
}
export function GetAnswerData(T) {
  let answer = [];

  for (let tIndex = 0; tIndex < T.length; tIndex++) {
    if (T[tIndex].type == 1 || T[tIndex].type == 2) {
      answer.push({
        parentId: 0,
        questionAnswer: Encrypt(
          T[tIndex].answer.join(","),
          T[tIndex].questionId
        ),
        questionId: T[tIndex].questionId,
        userAnswers: T[tIndex].userAnswer
      });
    } else {
      T[tIndex].sonQuestion.forEach(r => {
        answer.push({
          parentId: T[tIndex].questionId,
          questionAnswer: Encrypt(r.answer.join(","), r.questionId),
          questionId: r.questionId,
          userAnswers: r.userAnswer
        });
      });
    }
  }
  return answer;
}
export function GetExamAnswerData(T) {
  //考试用
  let answer = [];

  for (let tIndex = 0; tIndex < T.length; tIndex++) {
    if (T[tIndex].type == 1 || T[tIndex].type == 2) {
      answer.push({
        parentId: 0,
        optionFlag: T[tIndex].optionFlag,
        type: T[tIndex].type,
        questionAnswer: Encrypt(
          T[tIndex].answer.join(","),
          T[tIndex].questionId
        ),
        questionId: T[tIndex].questionId,
        userAnswers: T[tIndex].userAnswer
      });
    } else {
      T[tIndex].sonQuestion.forEach(r => {
        answer.push({
          optionFlag: T[tIndex].optionFlag,
          type: T[tIndex].type,
          parentId: T[tIndex].questionId,
          questionAnswer: Encrypt(r.answer.join(","), r.questionId),
          questionId: r.questionId,
          userAnswers: r.userAnswer
        });
      });
    }
  }
  return answer;
}
export function SelectTypeByTopicStudy(type, callback1, callback2, callback3) {
  if (type === 1 || type === 2) {
    callback1();
    return;
  }
  if (type === 3 || type === 4 || type === 7) {
    callback2();
    return;
  }
  if (type === 5 || type === 6 || type === 8) {
    callback3();
    return;
  }
}
export function GetErrorOrCorrect(T, type) {
  //type 1正确，2错误

  let newT = [];

  for (let tIndex = 0; tIndex < T.length; tIndex++) {
    if (T[tIndex].type == 1 || T[tIndex].type == 2) {
      if (T[tIndex].answerType == 1 && type == 1) {
        newT.push(T[tIndex]);
      }
      if (
        (T[tIndex].answerType == 2 || T[tIndex].answerType == 3) &&
        type == 2
      ) {
        newT.push(T[tIndex]);
      }
    } else {
      let answerType = 1;
      T[tIndex].sonQuestion.forEach((r, i) => {
        let question = T[tIndex].sonQuestion[i];
        if (question.answerType != 1) {
          answerType = 2;
        }
      });
      if (answerType == 1 && type == 1) {
        newT.push(T[tIndex]);
      }
      if (answerType == 2 && type == 2) {
        newT.push(T[tIndex]);
      }
    }
  }
  return newT;
}
